import React from 'react';
const Hospitals = () => <div className="service-page"><h1>Hospitals</h1><p>Find top hospitals for quality healthcare services.</p></div>;
export default Hospitals;
